// Vanilla CSS for Label. Prefix: lbl-. Aggregated into libraryStyles.
// The `font` prop remains caller-supplied (class string); .lbl-font is the
// vanilla default. border-width/color come from inline style; border-style is
// set here (Tailwind's preflight border-style:solid is gone after teardown).
export const labelStyles = `
  .lbl-box {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    border-style: solid;
    border-radius: var(--rad-catchup-2xlarge);
    text-align: center;
  }
  .lbl-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
  }
  .lbl-font { font-size: var(--fs-md); }
`;
